<template>
  <div>
    <v-row>
      <v-col cols="12">
        <!-- Medication -->
        <v-text-field
          v-model="form.medication"
          placeholder=" "
          class="primary-label"
        >
          <template v-slot:label>
            <span class="font-weight-bold">Medication</span>
          </template>
        </v-text-field>
      </v-col>
      <v-col cols="12">
        <!-- Allergies -->
        <v-text-field
          v-model="form.allergies"
          placeholder=" "
          class="primary-label"
        >
          <template v-slot:label>
            <span class="font-weight-bold">Allergies</span>
          </template>
        </v-text-field>
      </v-col>
      <v-col cols="12">
        <!-- Notes -->
        <v-text-field
          v-model="form.notes"
          placeholder=" "
          class="primary-label"
        >
          <template v-slot:label>
            <span class="font-weight-bold">Notes</span>
          </template>
        </v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    form: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
};
</script>